import {useEffect, useState} from 'react';

const useCurrentProductVariant = () => {
  const getProduct = () => window?.bargain?.product;

  const firstAvailableVariant = (product) => product?.variants?.find((variant) => variant?.available) || null;

  const detectVariant = () => {
    const product = getProduct();
    if (!product) return null;
    const url = new URL(window.location.href);
    const variantId = url?.searchParams?.get('variant');

    const variant = variantId ? product?.variants?.find((variant) => Number(variant?.id) === Number(variantId) && variant?.available) : firstAvailableVariant(product);

    if (!variant) {
      console.log('Variant not found or not available');
    }

    return {
      ...variant,
      price: (variant?.price / 100) || 0,
      productId: product?.id,
      variantId: variant?.id,
      productHandle: product?.handle,
      productTitle: `${product?.title}${variant?.title !== 'Default Title' ? ` - ${variant?.title}` : ''}`,
      imageURL: product?.featured_image || product?.images?.[0],
      collections: product?.collections || []
    };
  };

  const [currentVariant, setCurrentVariant] = useState(detectVariant());

  useEffect(() => {
    const handleUrlChange = () => setCurrentVariant(detectVariant());
    const observeUrlChanges = () => {
      let lastUrl = window.location.href;
      const observer = new MutationObserver(() => {
        const currentUrl = window.location.href;
        if (currentUrl !== lastUrl) {
          lastUrl = currentUrl;
          handleUrlChange();
        }
      });
      observer.observe(document, {subtree: true, childList: true});
      return observer;
    };
    const observer = observeUrlChanges();
    return () => observer.disconnect();
  }, []);

  return {currentVariant};
};

export default useCurrentProductVariant;
